import { z } from 'zod';
export const SEQUENCE_OUTCOMES = ['GOAL_MET', 'OPTED_OUT'];
export const SequenceContextSchema = z.object({
    sequenceId: z.string(),
    nodeId: z.string(),
    nodeIndex: z.number().int(),
    nodeTotal: z.number().int(),
});
//# sourceMappingURL=context.js.map